<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">계정 정보 수정</h2>

      <div class="form-wrap">
        <div class="form-group mb-8">
          <h3 class="title-type-3">아이디</h3>
          <div class="relative white rounded pa-6 pr-16 text-sm-body-1">
            {{ userId }}
          </div>
        </div>

        <div class="form-group mb-8">
          <h3 class="title-type-3">비밀번호</h3>
          <div class="relative white rounded pa-6 pr-16">
            <v-text-field
              class="input-custom-2"
              type="password"
              height="40px"
              v-model="passwordFirst"
              :rules="passwordRules"
              solo
              placeholder="영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상"
              :error-messages="passwordErrorMessage"
            ></v-text-field>
            <v-text-field
              class="input-custom-2"
              type="password"
              height="40px"
              v-model="passwordConfirm"
              :rules="passwordRulesConfirm"
              solo
              placeholder="변경할 비밀번호 확인"
              :error-messages="passwordConfirmErrorMessage"
            ></v-text-field>
          </div>
        </div>
      </div>
      <v-form ref="form" v-model="valid">
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              담당자 성명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-text-field
                class="input-custom-2"
                type="text"
                height="40px"
                v-model="managerName"
                :rules="mamagerNameRules"
                solo
                required
              ></v-text-field>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              권한분류
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <div v-if="isOwner">
                <template
                  v-if="
                    this.userInfo.type === constantUserType.Owner ||
                    this.userInfo.type === constantUserType.Admin ||
                    this.userInfo.type === constantUserType.Developer
                  "
                >
                  <v-select
                    required
                    :items="searchSelForOwner"
                    label="선택"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                  ></v-select>
                </template>
                <template v-else>
                  <v-select
                    required
                    :items="searchSelForUser"
                    :label="searchSelForUser[0]"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                    disabled
                  ></v-select>
                </template>
              </div>
              <div v-else>
                <template v-if="this.userInfo.type === constantUserType.Owner">
                  <v-select
                    required
                    :items="searchSelForAdmin"
                    label="Owner"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                    disabled
                  ></v-select>
                </template>
                <template
                  v-else-if="
                    this.userInfo.type === constantUserType.Admin ||
                    this.userInfo.type === constantUserType.Developer
                  "
                >
                  <v-select
                    required
                    :items="searchSelForAdmin"
                    label="Admin"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                    disabled
                  ></v-select>
                </template>
                <template v-else>
                  <v-select
                    required
                    :items="searchSelForUser"
                    :label="searchSelForUser[0]"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                    disabled
                  ></v-select>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!--// form-wrap -->
        <!--form-wrap-->
        <div
          v-if="
            this.userInfo.type === 'user' || this.searchSelChoice === 'User'
          "
          class="form-wrap"
        >
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              소속
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16 d-flex">
              <div class="pr-2">
                <v-text-field
                  required
                  class="input-custom-2"
                  height="40px"
                  v-model="adviertierName"
                  solo
                  readonly
                  style="width: 450px"
                ></v-text-field>
              </div>
              <v-btn
                large
                depressed
                max-height="40px"
                color="#fecd06"
                class="button-type-1"
                @click.stop="openPopup"
              >
                찾기
              </v-btn>
            </div>
          </div>
        </div>
        <!--//form-wrap-->
        <div class="relative white rounded pa-6 pr-16">
          <div class="form-row-1">
            <p class="label">발급일</p>
            <div class="write-con">
              <span class="text-value" v-if="userInfo.create_at">
                {{ userInfo.create_at | moment('YYYY.MM.DD(hh:mm:ss A)') }}
              </span>
            </div>
          </div>
          <div class="form-row-1">
            <p class="label">발급관리자</p>
            <div class="write-con">
              <span class="text-value">{{ creator.manager_name }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex justify-space-between mt-10">
          <div>
            <div v-if="isEditableLevel">
              <v-btn
                v-if="userInfo.is_valid === 'Y'"
                large
                depressed
                dark
                max-height="40px"
                color="#ff5959"
                class="button-type-1"
                @click="changeDisable('비활성화')"
              >
                비활성화
              </v-btn>
              <v-btn
                v-else
                large
                depressed
                dark
                max-height="40px"
                color="#2196f3"
                class="button-type-1 ml-4"
                @click="changeDisable('활성화')"
              >
                활성화
              </v-btn>
            </div>
          </div>
          <div>
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fff"
              class="button-type-1"
              @click.stop="cancel"
            >
              취소
            </v-btn>
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              class="button-type-1 ml-4"
              :disabled="!valid"
              @click.prevent="updateUserInfo"
            >
              완료
            </v-btn>
          </div>
        </div>
      </v-form>
    </div>
    <div v-if="this.searchAdveriser">
      <SearchAdvertiserModal
        v-model="searchAdveriser"
        @select:advertiser="selectAdvertiser"
      />
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="userDisable"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import { detailUser, updateUser } from '@/api/account';
import { validatePasword } from '@/utils/validation';
import SearchAdvertiserModal from '~@/modal/SearchAdvertiserModal';
import bus from '@/utils/bus.js';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { constantUserType } from '@/utils/constant';

export default {
  components: {
    SearchAdvertiserModal,
    SystemAlert,
  },
  data: () => ({
    valid: false,

    searchAdveriser: false,
    userInfo: {},

    searchSelForOwner: ['Owner', 'Admin', 'Developer', 'User'],
    searchSelForAdmin: ['Admin', 'Developer', 'User'],
    searchSelForUser: ['User'],
    searchSelChoice: '',

    userId: '',
    idRules: [
      v => !!v || '아이디를 입력해주세요.',
      v =>
        (v && /^[A-Za-z0-9]{6,20}$/.test(v)) ||
        '6~20자 영문(대,소문자 구분)/숫자만 사용 가능합니다.',
    ],
    passwordFirst: '',
    passwordRules: [v => !!v || '비밀번호를 입력해주세요.'],
    passwordConfirm: '',
    passwordRulesConfirm: [v => !!v || '비밀번호를 확인해주세요.'],

    managerName: '',
    mamagerNameRules: [v => !!v || '담당자 성명을 입력해 주세요.'],

    creator: {},

    adviertierName: '',
    adviertierId: '',
    showSystemAlert: false,
    logResult: '',
    resultType: null,

    confirmSystemAlert: false,
  }),
  computed: {
    passwordErrorMessage() {
      let str = '';
      if (this.passwordFirst && !validatePasword(this.passwordFirst)) {
        str =
          '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
      }
      return str;
    },
    passwordConfirmErrorMessage() {
      let str = '';
      if (this.passwordConfirm && !validatePasword(this.passwordConfirm)) {
        str =
          '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
      }
      return str;
    },
    isOwner() {
      return this.$store.getters.isOwner;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDeveloper() {
      return this.$store.getters.isDeveloper;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    constantUserType() {
      return constantUserType;
    },
    isEditableLevel() {
      const levels = { owner: 1, admin: 2, developer: 2, user: 3 };
      return levels[this.$store.state.user_type] <= levels[this.userInfo.type];
    },
  },
  methods: {
    selectAdvertiser(data) {
      this.adviertierName = data.name;
      this.adviertierId = data.id;
    },
    async getUserinfo() {
      const id = this.$route.params.id;
      try {
        const { data } = await detailUser(id);
        this.userInfo = data.row;
        this.userId = data.row.user_id;
        this.managerName = data.row.manager_name;
        if (data.row.hasOwnProperty('advertiser')) {
          this.adviertierName = data.row.advertiser.name;
        }
        this.creator = data.row.creator;
        this.searchSelChoice = this.capitalize(data.row.type);
        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
      }
    },

    async updateUserInfo() {
      const id = this.$route.params.id;
      try {
        if (this.passwordFirst !== this.passwordConfirm) {
          this.showSystemAlert = true;
          this.logResult = '비밀번호가 일치하지 않습니다.';
          return;
        } else {
          bus.$emit('start:spinner');
          const userData = {
            user_id: this.userId,
            password: this.passwordConfirm,
            manager_name: this.managerName,
            type: this.searchSelChoice.toLowerCase(),
            advertiser: {
              id: this.adviertierId,
            },
          };

          const { data } = await updateUser(id, userData);
          bus.$emit('end:spinner');
          this.resultType = data.result;
          if (data.result === 'success') {
            this.showSystemAlert = true;
            this.logResult = '수정정보를 저장하였습니다.';
          }
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        this.resultType = data.result;
        this.showSystemAlert = true;
        if (data.result === 'AlreadyUsedPassword') {
          this.logResult =
            '사용되었던 비밀번호입니다. <br>다른 비밀번호로 변경하여 주세요.';
        } else if (data.result === 'InvalidPassword') {
          this.logResult =
            '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
        } else if (data.result === 'DoesNotHavePermission') {
          this.logResult = `접속하신 계정은 관리 권한이 없습니다.<br/> VX사업부에 문의 부탁드립니다`;
        } else {
          this.logResult =
            '수정반영 중 에러가 발생했습니다.<br>재시도 부탁드립니다.';
        }
      }
    },
    openPopup() {
      this.searchAdveriser = true;
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router.push({ name: 'account' }).catch(() => {});
      }
    },
    cancel() {
      this.getUserinfo();
      this.$router.push({ name: 'account' }).catch(() => {});
    },
    capitalize(str) {
      if (!str) return '';
      str = str.toString();
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    changeDisable(msg) {
      this.confirmSystemAlert = true;
      this.isValid = msg === '비활성화' ? 'N' : 'Y';
      this.logResult = `계정을 정말 ${msg} 하시겠습니까?`;
    },
    async userDisable() {
      try {
        const id = this.$route.params.id;
        const { data } = await updateUser(id, { is_valid: this.isValid });
        if (data.result === 'success') {
          this.$router.push({ name: 'account' }).catch(() => {});
        }
      } catch (error) {
        console.log(error.response);
      }
    },
  },

  created() {
    bus.$emit('start:spinner');
    this.getUserinfo();
  },
  mounted() {},
};
</script>

<style></style>
